import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from 'sonner';
import { enableContentProtection } from './lib/contentProtection';

enableContentProtection();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster 
      position="top-right"
      toastOptions={{
        style: {
          background: '#0F0F11',
          color: '#F8F9FA',
          border: '1px solid rgba(212, 175, 55, 0.3)',
        },
      }}
    />
  </React.StrictMode>
);
